import { useShallow } from 'zustand/react/shallow';
import { useTreeStore } from '../store/TreeStore';
import { Step } from '@/backend/models/containers/step';
import { ContainerTreeObject } from '../types/navigationTypes';
import { useNavigate } from 'react-router-dom';
import { useProcedureInstanceStore } from '../store/ProcedureInstanceStore';

export function useGetNextStep(position?: number) {
  const containerLookup = useTreeStore(useShallow(state => Object.values(state.containerLookup)));
  if (position === undefined) return undefined;
  return containerLookup.find(container => container.stepPosition !== undefined && container.stepPosition === position + 1 && !container.container.isScaffold);
}

export function searchForNextStep(containers: ContainerTreeObject[]): ContainerTreeObject | undefined {
  const currentContainer = containers[0];
  if (currentContainer.container instanceof Step) return currentContainer;

  const foundChild = searchForNextStep(currentContainer.children);
  if (foundChild) return foundChild;

  return undefined;
}

export function useNavigateToNextStep(currentContainer: ContainerTreeObject) {
  const navigate = useNavigate();
  const procedure = useProcedureInstanceStore((state) => state.procedureInstance);
  const nextStep = useGetNextStep(currentContainer.stepPosition);

  return async () => {
    if (nextStep) {
      await navigate(`/procedures/wizard/${procedure?.id}/steps/${nextStep.id}`);
      document.getElementById('disable-container')?.scrollTo(0, 0);
    }
  };
}
